import React, { useEffect } from "react";

// ✅ Import images
import projectBg from "../../images/bg/project-bg.png";
import gifRound from "../../images/icon/b10c3e43e836d32554bf.gif";
import projectImg01 from "../../images/project/project-img01.jpg";
import projectImg02 from "../../images/project/project-img02.jpg";
import projectImg03 from "../../images/project/project-img03.jpg";
import projectImg04 from "../../images/project/project-img04.jpg";
import headingLogo from "../../images/logo/heading-logo.png";
// ✅ Import icons
import icon01 from "../../images/icon/project-icon01.svg";
import yecho from "../../images/logo/Yecho-logo.png";
import icon02 from "../../images/icon/project-icon02.svg";
import icon03 from "../../images/icon/project-icon03.svg";
import icon08 from "../../images/icon/project-icon08.svg";
import icon09 from "../../images/icon/project-icon09.svg";
import icon10 from "../../images/icon/project-icon10.svg";
import icon11 from "../../images/icon/project-icon11.svg";
import icon12 from "../../images/icon/project-icon12.svg";
import icon13 from "../../images/icon/project-icon13.svg";
import Icons23 from "../../images/icon/tech2.jpeg";
import Icons24 from "../../images/icon/tech3.jpeg";
import Icons25 from "../../images/icon/tech42.jpeg";
import Icons26 from "../../images/icon/tech5.jpeg";
import { Link } from "react-router-dom";
import VideoModal from "../ModalVideo/VideoModal";

const ProjectSection: React.FC = () => {
  useEffect(() => {
    // ✅ Set dynamic background image
    const bgElement = document.querySelector<HTMLElement>(".project.bg_img");
    if (bgElement) {
      bgElement.style.backgroundImage = `url(${projectBg})`;
    }

    // ✅ Scroll activation logic
    const items = document.querySelectorAll<HTMLElement>(".xb-project-item");
    const paginations = document.querySelectorAll<HTMLElement>(".xb-project-pagination li");

    if (!items.length || !paginations.length) return;

    items.forEach((item) => {
      item.style.transition = "opacity 0.6s ease";
      item.style.opacity = "1";
    });

    const updateActive = () => {
      let indexToActivate = 0;
      const triggerLine = window.innerHeight * 0.3;

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        if (rect.top <= triggerLine) {
          indexToActivate = index;
        }
      });

      paginations.forEach((el) => el.classList.remove("active"));
      if (paginations[indexToActivate]) {
        paginations[indexToActivate].classList.add("active");
      }

      items.forEach((item, i) => {
        if (i === indexToActivate) {
          item.style.opacity = "1";
        } else if (i < indexToActivate) {
          item.style.opacity = "0.3";
        } else {
          item.style.opacity = "1";
        }
      });
    };

    window.addEventListener("scroll", updateActive);
    updateActive();

    return () => {
      window.removeEventListener("scroll", updateActive);
    };
  }, []);

  return (
    <section className="project bg_img pt-135 pb-150">
      <div className="container">
        <div className="sec-title custom-sec-title xb-sec-padding text-center">
          <h2 className="title">
            {/* <span className="round-img">
              <img src={gifRound} alt="animation" />
            </span>{" "} */}
            Intelligent systems we build
          </h2>
        </div>
      </div>

      <div className="container mxw-1800">
        <div className="xb-project-wrap">
          {/* Pagination */}
          <div className="xb-project-pagination-wrap">
            <ul className="xb-project-pagination">
              {/* <li>1</li>
              <li className="active">2</li>
              <li>3</li>
              <li>4</li> */}
            </ul>
          </div>

          {/* Project items */}
          <div className="xb-project-inner">
            {[
              {
                img: projectImg01,
                title: "Yecho Bot",
                desc: "Yecho, your AI-powered digital teammate, is designed to make your work easier and more productive. Instead of jumping between apps, you can simply chat with Yecho to instantly get answers pulled directly from your internal work documents and files. But it does more than just answer questions,it connects seamlessly to the tools you already use. Need to create or check on a project task? Yecho manages your Jira tickets right from the chat. Having IT issues? It smoothly handles all your ServiceNow support requests. Plus, with built-in broadcasts, you'll never miss important company-wide announcements. Yecho is your secure, knowledgeable, and always-available teammate, right inside your everyday chat window.",
                industry: "Data Processing",
                country: "Germany, Issum",
                techs: [Icons26, Icons23, Icons24, Icons25]
              },
              // {
              //   img: projectImg02,
              //   title: "E-commerce & marketing..",
              //   desc: "We create AI solutions that boost sales and customer engagement—like smart product recommendations, dynamic pricing, and behavior-based targeting. Our tools help brands personalize experiences and grow faster.",
              //   industry: "Artificial Intelligence",
              //   country: "Singapore",
              //   techs: [icon01, icon08, icon09],
              // },
              // {
              //   img: projectImg03,
              //   title: "Computer vision projects..",
              //   desc: "We develop AI systems that see and understand visual data—detecting objects, recognizing patterns, and automating inspections. Our computer vision solutions help businesses improve accuracy, decision-making.",
              //   industry: "Computer Vision",
              //   country: "United States",
              //   techs: [icon10, icon11, icon01],
              // },
              // {
              //   img: projectImg04,
              //   title: "Data science analytics..",
              //   desc: "We turn complex data into clear, actionable insights. From predictive models to real-time dashboards, our AI-powered analytics help businesses make smarter, faster decisions with confidence.",
              //   industry: "Data Science",
              //   country: "Canada",
              //   techs: [icon08, icon12, icon13],
              // },
            ].map((project, index) => (
              <div
                key={index}
                className="xb-project-item bg_img"
                // style={{ backgroundImage: `url(${project.img})` }}
              >
                <div className="xb-project-content">
                  <div className="xb-item--inner xb-border">
                    <h2 className="xb-item--title xb-item--title-with-logo">
                      <img
                        src={headingLogo}
                        alt=""
                        className="xb-item--title-logo"
                        aria-hidden="true"
                      />
                      <span>{project.title}</span>
                    </h2>
                    <p className="xb-item--content">{project.desc}</p>
                    {/* <ul className="xb-item--list ul_li"> */}
                      {/* <li>
                        Industry: <span>{project.industry}</span>
                      </li>
                      <li>
                        Country: <span>{project.country}</span>
                      </li>
                    </ul> */}
                    <div className="xb-item--technologie ul_li mt-20">
                      <span>Core Technologies:</span>
                      <ul className="list-unstyled ul_li d-flex flex-wrap gap-2 mt-10">
                        {project.techs.map((icon, i) => (
                          <li key={i} className="overflow-hidden">
                            <img src={icon} alt="icon" className="w-100 h-100 object-fit-cover rounded-circle" />
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="xb-item--tutorial mt-20">
                      <VideoModal
                        videoUrl="https://youtu.be/AirTQw-xrxY"
                        triggerText="How it works"
                      />
                    </div>
                  
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
